import React from 'react';
import { motion } from 'framer-motion';
const findings = [{
  number: '01',
  source: 'WASSERMAN, HBS',
  text: 'Startups with clear decision-making frameworks and explicit role definitions have significantly higher survival rates.',
  citation: "The Founder's Dilemmas, 2012",
  link: 'https://www.hbs.edu/faculty/Pages/item.aspx?num=42425'
}, {
  number: '02',
  source: 'MCCARTHY ET AL.',
  text: 'Founding a startup is a team sport—complementary personalities have an outsized impact on venture success.',
  citation: 'Scientific Reports, 2023',
  link: 'https://www.nature.com/articles/s41598-023-41980-y'
}, {
  number: '03',
  source: 'FIRST ROUND CAPITAL',
  text: 'Teams with female cofounders performed 63% better than all-male founding teams in their 10-year portfolio analysis.',
  citation: '10 Year Project, 2015',
  link: 'https://10years.firstround.com/'
}, {
  number: '04',
  source: 'YAEL DANIELY',
  text: '55% of co-founder relationships end within 4 years, highlighting the critical importance of early alignment and ongoing communication.',
  citation: '400+ Founder Study, 2019-2021',
  link: 'https://yaeldaniely.com/2023/09/09/unspoken-yet-lethal-dysfunctional-co-founders-relationships/'
}, {
  number: '05',
  source: 'WINSAVVY',
  text: '33% of founders cite misaligned vision as the core reason for conflict, underscoring the need for explicit alignment on goals and strategy.',
  citation: 'Founder Research',
  link: 'https://www.winsavvy.com/founder-conflicts-and-startup-failure-correlation-stats-you-should-know/'
}, {
  number: '06',
  source: 'PAUL GRAHAM, YC',
  text: '20% of Y Combinator startups have experienced a co-founder departure, demonstrating that even top-tier teams face partnership challenges.',
  citation: 'Y Combinator',
  link: 'https://medium.com/getshuffleapp/a-simple-framework-to-assess-your-co-founder-fit-f55aee1a449b'
}];
export function KeyFindingsSection() {
  return <section id="key-findings" className="px-4 sm:px-8 md:px-[60px] py-[140px] bg-white" data-id="element-1082">
      <div className="max-w-[1400px] mx-auto" data-id="element-1083">
        <div className="grid lg:grid-cols-2 gap-[80px] items-start" data-id="element-1084">
          {/* Left: Section Header */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-1085">
            <div className="inline-flex items-center px-4 py-2 rounded bg-[#1A3D3A] text-white mb-8" style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: '12px',
            fontWeight: 600,
            letterSpacing: '3px',
            lineHeight: 1.0,
            borderRadius: '4px'
          }} data-id="element-1086">
              KEY FINDINGS
            </div>
            <h2 className="text-[#1A3D3A] mb-6" style={{
            fontFamily: "'Cormorant Garamond', serif",
            fontSize: 'clamp(40px, 5vw, 56px)',
            fontWeight: 500,
            lineHeight: 1.1,
            letterSpacing: '-1px'
          }} data-id="element-1087">
              What the Research Shows
            </h2>
            <p className="text-[#3D5654]" style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: '17px',
            fontWeight: 400,
            lineHeight: 1.8
          }} data-id="element-1088">
              Validated insights from peer-reviewed studies and longitudinal
              founder research. Full methodology available to research
              participants.
            </p>
          </motion.div>

          {/* Right: Findings Cards */}
          <div className="space-y-6" data-id="element-1089">
            {findings.map((finding, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1,
            duration: 0.5
          }} className="bg-white rounded-[12px] p-8 border-l-4 border-[#C5F467] relative" style={{
            boxShadow: '0 8px 40px rgba(26, 61, 58, 0.1)'
          }} data-id="element-1090">
                <div className="flex items-start gap-4 mb-4" data-id="element-1091">
                  <div className="bg-[#1A3D3A] text-white px-3 py-1 rounded flex-shrink-0" style={{
                fontFamily: "'DM Sans', sans-serif",
                fontSize: '12px',
                fontWeight: 600,
                borderRadius: '4px'
              }} data-id="element-1092">
                    {finding.number}
                  </div>
                  <a href={finding.link} target="_blank" rel="noopener noreferrer" className="text-[#1A3D3A] hover:text-[#3D5654] transition-colors" style={{
                fontFamily: "'DM Sans', sans-serif",
                fontSize: '11px',
                fontWeight: 600,
                letterSpacing: '1px',
                lineHeight: 1.4
              }} data-id="element-1093">
                    {finding.source}
                  </a>
                </div>
                <p className="text-[#1A3D3A] mb-4" style={{
              fontFamily: "'Cormorant Garamond', serif",
              fontSize: '22px',
              fontWeight: 400,
              lineHeight: 1.5
            }} data-id="element-1094">
                  {finding.text}
                </p>
                <p className="text-[#3D5654] italic" style={{
              fontFamily: "'DM Sans', sans-serif",
              fontSize: '13px',
              fontWeight: 400
            }} data-id="element-1095">
                  — {finding.citation}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}